const NS = 'WoolLabInteractiveMoodboardBlock';
const CLS = 'woolLabInteractiveMoodboardBlock';

import Handlebars from 'handlebars';
import {WoolLabShareSwatchModalBlock} from './woolLabShareSwatchModalBlock';
import {WoolLabRenameMoodboardModalBlock} from './woolLabRenameMoodboardModalBlock';
import _, { ceil } from 'lodash';

import Konva from 'konva';
import jsPDF from '@mathiasosterkamp/customjspdf';

export class WoolLabInteractiveMoodboardBlock {
	constructor(el) {
		this.$el = $(el);

		this.autoSaveTimeout = 5000;

		this.activeSwatchId = 99999;
		this.activeImageCanvasId = 99999;
		this.activeNoteId = 99999;
		this.isAddNoteActive = false;

		this.zoomIncriment = 0.1;
		this.scale = 1;
		this.newItemGridSpacing = 500;

		this.$persistentDrawAddMoodboardBtn = $('.woolLabPersistentSwatchDrawer-addToMoodboardBtn');
		this.$persistentDrawSwatches = $('.woolLabPersistentSwatchDrawer-swatches');

		this.moodboardName = '';
		var searchParams = new URLSearchParams(window.location.search)
		this.moodboardId = searchParams.get('id');

		this.swatchIds = [];

		this.$canvasContainer = this.$el.find(`.${CLS}-canvasContainer`);

		this.$notepad = this.$el.find(`.${CLS}-notepad`);

		this.$resetCanvasBtn = this.$el.find(`.${CLS}-resetCanvasBtn`);
		this.$addNoteBtn = this.$el.find(`.${CLS}-addNoteBtn`);

		this.$notepadCloseBtn = this.$el.find(`.${CLS}-notepad-closeBtn`);
		this.$notepadDeleteBtn = this.$el.find(`.${CLS}-notepad-deleteBtn`);
		this.$notepadPostBtn = this.$el.find(`.${CLS}-notepad-postBtn`);

		this.$zoomInBtn = this.$el.find(`.${CLS}-zoomInBtn`);
		this.$zoomOutBtn = this.$el.find(`.${CLS}-zoomOutBtn`);

		this.getMoodboardApi = this.$el.data('getMoodboardApi');
		this.updateMoodboardApi = this.$el.data('updateMoodboardApi');
		this.deleteMoodboardApi = this.$el.data('deleteMoodboardApi');
		this.shareSwatchesApi = this.$el.data('shareSwatchesApi');
		this.addToMySwatchesApi = this.$el.data('addToMyswatchesApi');
		this.myMoodboardsUrl = this.$el.data('myMoodboardsUrl');
		this.moodboardNoteImg = this.$el.data('moodboardNoteImg');
		this.noteCursorImg = this.$el.data('noteCursorImg');
		this.notesHoverText=this.$el.data('notesHoverText');
		this.centreHoverText=this.$el.data('centreHoverText');
		
		this.$loadingScreen = this.$el.find(`.${CLS}-searchResults-loadingScreen`);

		this.$optionsBtn = this.$el.find(`.${CLS}-optionsBtn`);
		this.$optionsDropdown = this.$el.find(`.${CLS}-options-dropdown`);

		this.$optionsRenameBtn = this.$el.find(`.${CLS}-options-rename`);
		this.$optionsShareBtn = this.$el.find(`.${CLS}-options-share`);
		this.$optionsDeleteBtn = this.$el.find(`.${CLS}-options-remove`);

		this.$deleteMoodboardPanel = this.$el.find(`.${CLS}-mooboardDelete-panel`);
		this.$deleteMoodboardPanelDeleteBtn = this.$el.find(`.${CLS}-mooboardDelete-removePanel-remove`);
		this.$deleteMoodboardPanelCancelBtn = this.$el.find(`.${CLS}-mooboardDelete-removePanel-cancel`);

		this.$contextMenu = this.$el.find('#moodboardContextMenu');
		this.$contextMenuUpButton = this.$el.find('#moodboardContextUpButton');
		this.$contextMenuDownButton = this.$el.find('#moodboardContextDownButton');

		this.$selectOptionsPanel = this.$el.find(`.${CLS}-selectOptions-panel`);
		this.$selectOptionsAddMySwatchedBtn = this.$el.find(`.${CLS}-selectOptions-addMySwatches`);
		this.$selectOptionsRemoveBtn = this.$el.find(`.${CLS}-selectOptions-remove`);
		this.$selectOptionsCloseBtn = this.$el.find(`.${CLS}-selectOptions-close`);


		this.initNotepad();
		this.handleOptionBtns();
		this.handleDeleteMoodboardBtns();
		this.handleSelectOptionsButtons();
		this.handleNotepadButtons();
		this.handleCanvasButtons();
		this.getItems();
		this.initCanvas();

		setInterval(() => {
			this.checkIfMoodboardChanged();
		}, this.autoSaveTimeout);
	}

	initNotepad() {
		// TinyMCE
		if (typeof tinymce === 'object') {
			// eslint-disable-next-line no-undef
			tinymce.init({
				selector: `#notepadEditor`,
				plugins: 'lists',
				content_style: 'body { margin: 0;}' + 'p {margin: 0; font-weight: 20px; line-height: 30px; padding-right: 40px;}' + 'body::before {font-weight: 20px; line-height: 30px; color: #000000 !important; opacity: 0.3;}',
				menubar: false,
				statusbar: false,
				paste_as_text: true,
				height: '100%',
				toolbar: 'bold italic bullist | customDownloadButton customSaveButton',
			});
		}
	}

	initCanvas() {
		const This = this;

		let sceneWidth = this.$canvasContainer.width();
		let sceneHeight = this.$canvasContainer.height();

		this.stage = new Konva.Stage({
			container: 'canvasContainer',
			width: sceneWidth,
			height: sceneHeight,
			draggable: true,
		});

		this.layer = new Konva.Layer();
		this.stage.add(this.layer);

		this.stage.on('click', function() {
			if (This.isAddNoteActive) {
				let pos = This.layer.getRelativePointerPosition();

				pos.x -= 40;
				pos.y -= 40;

				This.deactivateAddNote();
				This.generateNote(pos, true);
			}
		});

		this.stage.on('mouseenter mouseup', () => {
			if (!this.isAddNoteActive) {
				this.stage.container().style.cursor = 'grab';
			}
		});
		this.stage.on('mousedown', (e) => {
			if (e.target === this.stage) {
				this.transformer.nodes([]);
				this.closeSelectOptions();
			}
			if (!this.isAddNoteActive) {
				this.stage.container().style.cursor = 'grabbing';
			}
		});

		// variable to temporarily hold swatch that is being "right-click"ed
		let selectedItem;

		// Context menu set up
		this.stage.on('contextmenu', function (e) {
			// prevent default behavior
			e.evt.preventDefault();
			if (e.target === This.stage) {
			  // if we are on empty place of the stage we will do nothing
			  return;
			}

			selectedItem = e.target;

			// show menu
			This.$contextMenu.css('display', 'initial');
			var containerRect = This.stage.container().getBoundingClientRect();
			This.$contextMenu.css('top', containerRect.top + This.stage.getPointerPosition().y + 4 + 'px');
			This.$contextMenu.css('left', containerRect.left + This.stage.getPointerPosition().x + 4 + 'px');
		});

		this.$contextMenuUpButton.on('click', () => {
			selectedItem && selectedItem.moveUp();
		});

		this.$contextMenuDownButton.on('click', () => {
			selectedItem && selectedItem.moveDown();
		});

		// hide context menu
		$(window).on('click', () => {
			This.$contextMenu.css('display', 'none');
		});

		this.transformer = new Konva.Transformer({
			keepRatio: true,
			enabledAnchors: [
			'top-left',
			'top-right',
			'bottom-left',
			'bottom-right',
			],
			anchorStroke: 'black',
			anchorFill: 'white',
			anchorSize: 12,
			borderStroke: 'black',
			rotateAnchorOffset: 50,
			padding: 10,
		});

		function fitStageIntoParentContainer() {
			This.stage.width(This.$canvasContainer.width());
			This.stage.height(This.$canvasContainer.height());
		}
		fitStageIntoParentContainer();

		window.addEventListener('resize', fitStageIntoParentContainer);
	}

	saveItems() {
		let url = `${this.updateMoodboardApi}`;
		let data = JSON.stringify(this.getMoodboardJSON());

		fetch(url, {
			method: 'POST',
			dataType: 'json',
			body: data
		}).then((response) => {
			this.$loadingScreen.removeClass('active');
			return response.json();
		}).then((_json) => {
		}).catch((_error) => {
		});
	}

	saveSwatchesFromPD() {
		let url = `${this.updateMoodboardApi}`;
		const moodboardJSON=this.getMoodboardJSON();
		moodboardJSON.salesforce="true";
		let data = JSON.stringify(moodboardJSON);

		fetch(url, {
			method: 'POST',
			dataType: 'json',
			body: data
		}).then((response) => {
			this.$loadingScreen.removeClass('active');
			return response.json();
		}).then((_json) => {
		}).catch((_error) => {
		});
	}

	checkIfMoodboardChanged() {
		if (!this.previousMoodboardJSON) {
			this.previousMoodboardJSON = this.getMoodboardJSON();
		} else if ( !_.isEqual(this.previousMoodboardJSON, this.getMoodboardJSON())) {
			// moodboard has changed since last check
			this.previousMoodboardJSON = this.getMoodboardJSON();
			this.saveItems();
		}
	}

	getMoodboardJSON() {
		let data = {};
		let items = [];
		

		this.layer.getChildren((node) => {
			let itemType = node.attrs.itemType;

			if (itemType === 'swatch' || itemType === 'image' || itemType === 'notes') {
				let item = {};
				item.type = itemType;
				item.transformation = node.toJSON();

				if (itemType === 'swatch') {
					item.swatch = {
						'id': node.attrs.swatchId,
						'fullImageSrc': node.attrs.swatchImgSrc,
					};
				} else if (itemType === 'image') {
					item.imageUrl = node.attrs.imgSrc;
				}

				items.push(item);
			}
		});

		data.id = this.moodboardId;
		data.title = this.moodboardName;
		data.items = items;

		return data;
	}

	

	getItems() {
		let url = `${this.getMoodboardApi}?moodboardId=${this.moodboardId}`;

		this.$loadingScreen.addClass('active');

		$.ajax({
			type: 'GET',
			url: url,
			success: (data) => {

				this.moodboardName = data.title;
				this.moodboardId = data.id;

				if (data.items.length > 0) {
					let newItemInt = 0;

					data.items.forEach((item, i) => {
						let transformationAttrs;

						if (item.transformation) {
							let transformation = JSON.parse(item.transformation);
							if (transformation.attrs) {
								transformationAttrs = transformation.attrs;
							}
						}

						let offsetX = 100 + (this.newItemGridSpacing * newItemInt);
						let offsetY = 100;

						let pos = {x: offsetX, y: offsetY};

						if (!transformationAttrs) {
							newItemInt++;
						}
						if (item.type === 'image' || item.type === 'swatch') {
							this.generateImage(pos, item, transformationAttrs);
						} else if (item.type === 'notes') {
							this.generateNote(pos, false, transformationAttrs);
						}
					});
				}

				this.$loadingScreen.removeClass('active');
			},
			error: (error) => {
			},
			complete: () => {
				$('#InteractiveMoodboardName').html(this.moodboardName);
			},
		});
	}

	generateImage(pos, item, transformationAttrs) {
		const This = this;

		let imageObj = new Image();

		imageObj.onload = function() {
			This.scaleCenterView();
		}

		let img = new Konva.Image({
			x: pos.x,
			y: pos.y,
			image: imageObj,
			draggable: true,
			scaleX: 0.5,
			scaleY: 0.5,
			cornerRadius: 10,
		});

		if (transformationAttrs) {
			img.setAttrs(transformationAttrs);
		}

		if (item.type === 'image') {
			img.setAttrs({'itemType': 'image', 'imgSrc': item.imageUrl});
		} else {
			img.setAttrs({'itemType': 'swatch', 'swatchId': item.swatch.id, 'swatchImgSrc': item.swatch.fullImageSrc});
			This.swatchIds.push(item.swatch.id);
		}

		img.on('mousedown touchstart', (e) => {
			if (!This.isAddNoteActive) {
				This.transformer.nodes([img]);
				This.transformer.rotateEnabled(true);
				This.layer.add(This.transformer);

				This.activeImageCanvasId = img._id;

				if (item.type === 'image') {
					This.openSelectOptions();
				} else {
					This.openSelectOptions(item.swatch.id);
				}
			}
		});

		img.on('mouseenter', (e) => {
			if (!This.isAddNoteActive) {
				This.stage.container().style.cursor = 'pointer';
			}
		});

		img.on('mouseleave', (e) => {
			if (!This.isAddNoteActive) {
				This.stage.container().style.cursor = 'grab';
			}
		});

		This.layer.add(img);
		
		if (item.type === 'image') {
			imageObj.src = item.imageUrl;
		} else {
			imageObj.src = item.swatch.fullImageSrc;
		}
	}

	generateNote(pos, openNotepad, transformationAttrs) {
		const This = this;
		let svgUrl = '../assets/images/singles/moodboard-note.svg';

		Konva.Image.fromURL(this.moodboardNoteImg, (imageNode) => {
			This.layer.add(imageNode);

			imageNode.setAttrs({
				x: pos.x,
				y: pos.y,
				width: 80,
				height: 80,
				draggable: true,
				dataNote: ' ',
				itemType: 'notes',
			});

			if (transformationAttrs) {
				imageNode.setAttrs(transformationAttrs);
			}

			// on note clicked add to transform node
			imageNode.on('mousedown touchstart', (e) => {
				if (!This.isAddNoteActive) {
					This.transformer.nodes([imageNode]);
					This.transformer.rotateEnabled(false);
					This.layer.add(This.transformer);
				}
			});

			// on note clicked open up notepad
			imageNode.on('mouseup touchend', (e) => {
				if (!This.isAddNoteActive) {
					if (imageNode.getAttr('dataNote')) {
						This.openNotepad({
							dataNote: imageNode.getAttr('dataNote'),
							id: imageNode._id,
						});
					} else {
						This.openNotepad();
					}
				}
			});

			imageNode.on('mouseenter', (e) => {
				if (!This.isAddNoteActive) {
					This.stage.container().style.cursor = 'pointer';
				}
			});

			imageNode.on('mouseleave', (e) => {
				if (!This.isAddNoteActive) {
					This.stage.container().style.cursor = 'grab';
				}
			});

			if (openNotepad) {
				This.transformer.nodes([imageNode]);
				This.transformer.moveToTop();
				This.transformer.rotateEnabled(false);
				This.layer.add(This.transformer);
				This.openNotepad({
					dataNote: imageNode.getAttr('dataNote'),
					id: imageNode._id,
				});
			}
		});
	}

	activateAddNote() {
		this.stage.container().style.cursor = `url(${this.noteCursorImg}), auto`;
		this.$addNoteBtn.addClass('active');
		this.isAddNoteActive = true;
	}
	deactivateAddNote() {
		this.stage.container().style.cursor = 'auto';
		this.$addNoteBtn.removeClass('active');
		this.isAddNoteActive = false;
	}

	handleCanvasButtons() {
		this.$resetCanvasBtn.on('click', (e) => {
			this.scaleCenterView();
		});

		this.$resetCanvasBtn.on('mouseover', (e) => {
			this.$resetCanvasBtn.css('cursor','pointer').attr('title',this.centreHoverText);
			
		});

		this.$addNoteBtn.on('click', (e) => {
			// this.openNotepad();
			if (this.$addNoteBtn.hasClass('active')) {
				this.deactivateAddNote();
			} else {
				this.activateAddNote();
			}
		});
		this.$addNoteBtn.on('mouseover', (e) => {
			this.$addNoteBtn.css('cursor','pointer').attr('title',this.notesHoverText);
		});
		this.$zoomInBtn.on('click', (e) => {
			this.scale = this.zoom(this.stage, this.scale, this.zoomIncriment);
		});
		this.$zoomOutBtn.on('click', (e) => {
			this.scale = this.zoom(this.stage, this.scale, -this.zoomIncriment);
		});

		this.$persistentDrawAddMoodboardBtn.on('click', () => {
			let selectedSwatches = [];
			this.$persistentDrawSwatches.find('.woolLabPersistentSwatchDrawer-swatch.selected').each(function(i, item) {
				let selectedSwatch = {'id': $(item).attr('data-id'), 'fullImageSrc': $(item).attr('data-img-src') };
				selectedSwatches.push(selectedSwatch);
			});
			this.addSwatchesToMoodboard(selectedSwatches);
		});
	}

	handleNotepadButtons() {
		this.$notepadCloseBtn.on('click', (e) => {
			this.closeNotepad();
		});
		this.$notepadPostBtn.on('click', (e) => {
			this.closeNotepad();
			this.saveItems();
		});
		this.$notepadDeleteBtn.on('click', (e) => {
			this.closeNotepad();
			this.removeItemFromMoodboard(this.activeNoteId);
		});
	}

	removeItemFromMoodboard(itemCanvasId) {
		const This = this;
		this.layer.getChildren(function(node) {
			if (node._id === itemCanvasId) {
				node.destroy();
				This.transformer.nodes([]);
			}
		});
		this.saveItems();
	}

	scaleCenterView() {
		let padding = 50;

		let yMin = 0;

		let xMin = 0;
		let xMax = 1000;
		this.layer.getChildren(function (node) {
			if (node.attrs.x < xMin) {
				xMin = node.attrs.x;
			}

			let nodeWidth = 0;

			if (node.getClassName() === 'Image') {
				if (node.attrs.width) {
					nodeWidth = node.attrs.width;
				} else if (node.attrs.image.width) {
					nodeWidth = node.attrs.image.width;
					let scaleX = node.attrs.scaleX ? node.attrs.scaleX : 1;
					nodeWidth = scaleX * nodeWidth;
				}
			}

			if (node.attrs.x + nodeWidth > xMax) {
				xMax = node.attrs.x + nodeWidth;
			}

			if (node.attrs.y < yMin) {
				yMin = node.attrs.y;
			}
		});

		let xDif = xMax - xMin + (2 * padding);
		this.scale = this.stage.width() / xDif;

		let xPos = (xMin - padding) * -this.scale;
		let yPos = (yMin - padding) * -this.scale;

		this.stage.scale({x: this.scale, y: this.scale});
		this.stage.position({x: xPos, y: yPos});
	}


	zoom(stage, zoomBefore, inc) {
		let oldScale = stage.scaleX();

		let zoomPoint = {
			x: ((stage.width() / 2) - stage.x()) / oldScale,
			y: ((stage.height() / 2) - stage.y()) / oldScale,
		};

		let zoomAfter = zoomBefore + (zoomBefore * inc);

		stage.scale({x: zoomAfter, y: zoomAfter});

		let newPos = {
			x: (stage.width() / 2) - zoomPoint.x * zoomAfter,
			y: (stage.height() / 2) - zoomPoint.y * zoomAfter,
		};

		stage.position(newPos);

		return zoomAfter;
	}

	openSelectOptions(swatchId) {
		if (swatchId) {
			this.activeSwatchId = swatchId;
			this.$selectOptionsAddMySwatchedBtn.addClass('active');
		} else {
			this.$selectOptionsAddMySwatchedBtn.removeClass('active');
		}
		this.$selectOptionsPanel.addClass('active');
		this.closeNotepad();
	}
	closeSelectOptions() {
		this.$selectOptionsAddMySwatchedBtn.removeClass('active');
		this.$selectOptionsPanel.removeClass('active');
	}

	openNotepad({dataNote, id}) {
		this.closeSelectOptions();
		if ( this.$notepad.hasClass('active')) {
			this.saveNotepadText();
		}

		if (id) {
			this.activeNoteId = id;
		}

		if (dataNote && typeof tinymce === 'object') {
			// eslint-disable-next-line no-undef
			tinymce.activeEditor.setContent(dataNote);
		}

		this.$notepad.addClass('active');
	}

	closeNotepad() {
		if (this.$notepad.hasClass('active')) {
			this.saveNotepadText();
			this.$notepad.removeClass('active');
		}
	}

	saveNotepadText() {
		const This = this;

		if (typeof tinymce === 'object') {
			// eslint-disable-next-line no-undef
			let notepadContent = tinymce.activeEditor.getContent();

			// find active note and update text
			this.layer.getChildren(function(node) {
				if (node._id === This.activeNoteId && notepadContent !== '') {
					node.setAttr('dataNote', notepadContent);
				}
			});
		}
	}


	handleOptionBtns() {
		this.$optionsBtn.on('click', (e) => {
			this.$optionsDropdown.toggleClass('active');
		});


		this.$optionsRenameBtn.on('click', (e) => {
			this.displayRenameMoodboardModal();
		});

		this.$optionsShareBtn.on('click', (e) => {
			this.generatePdf();
		});

		this.$optionsDeleteBtn.on('click', (e) => {
			this.$deleteMoodboardPanel.addClass('active');
        });
	}

	handleSelectOptionsButtons() {
		this.$selectOptionsAddMySwatchedBtn.on('click', (e) => {
			this.addSwatchToMySwatches();
			this.closeSelectOptions();
        });
		this.$selectOptionsRemoveBtn.on('click', (e) => {
			this.removeItemFromMoodboard(this.activeImageCanvasId);
			this.closeSelectOptions();
        });
		this.$selectOptionsCloseBtn.on('click', (e) => {
			this.closeSelectOptions();
        });
	}

	addSwatchToMySwatches() {
		let url = `${this.addToMySwatchesApi}`;

		this.$loadingScreen.addClass('active');
		$.ajax({
			data: JSON.stringify([this.activeSwatchId]),
			dataType: 'json',
			type: 'POST',
			url: url,
			success: (data) => {
				this.$loadingScreen.removeClass('active');
			},
		});
	}

	handleDeleteMoodboardBtns() {
		this.$deleteMoodboardPanelDeleteBtn.on('click', (e) => {
			let url = `${this.deleteMoodboardApi}`;
			let data = JSON.stringify({id: this.moodboardId});

			this.$loadingScreen.addClass('active');
			this.$deleteMoodboardPanel.removeClass('active');


			fetch(url, {
				method: 'POST',
				dataType: 'json',
				body: data
			}).then((response) => {
				this.$loadingScreen.removeClass('active');
				window.location.href = this.myMoodboardsUrl;
			}).catch((_error) => {
			});
		});

		this.$deleteMoodboardPanelCancelBtn.on('click', (e) => {
			this.$deleteMoodboardPanel.removeClass('active');
        });
		this.$deleteMoodboardPanel.on('click', (e) => {
			if ($(e.target).hasClass(`${CLS}-mooboardDelete-background`)) {
				this.$deleteMoodboardPanel.removeClass('active');
			}
        });
	}

	getShareSwatchModalTemplate() {
        let modalWidget = require('../../partials/widgets/woolLabShareSwatchModalBlock.hbs');

		Handlebars.registerPartial('woolLabShareSwatchModalBlock', modalWidget);

		let template = `
			{{> woolLabShareSwatchModalBlock
				wg="woolLabShareSwatchModalBlock"
				ns="WoolLabShareSwatchModalBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	generatePdf(){
		let stageCopy = this.stage.clone();
		var width = this.stage.width() / this.scale;
		var height = this.stage.height() / this.scale;
		var posX = -this.stage.x() / this.scale;
		var posY = -this.stage.y() / this.scale;


        var pdf = new jsPDF('l', "pt", [width, height]);

		var layer = new Konva.Layer();
		stageCopy.add(layer);

		var background = new Konva.Rect({
			x: posX,
			y: posY,
			width: width,
			height: height,
			fill: '#F9F9F9'
		});

		layer.add(background);
		layer.moveToBottom();

		pdf.addImage(
			stageCopy.toDataURL({ mimeType: 'image/jpeg', pixelRatio: 3, quality: 1 }),
			'jpeg',
			0,
			0,
			width,
			height
		);

		var notes = stageCopy.find(node => {
			return node.attrs.itemType == 'notes';
		});

		if (notes.length > 0){
			let nodeIndex = 0;
			let pageCount = 1;
			let columnSplit = 4;
			let dataPageWidth = 1500;
			let dataPageHeight = dataPageWidth * (height / width);
			let margin = dataPageWidth / 20;
			let columnWidth = dataPageWidth / columnSplit - margin;

			//We use this recursive function due to an issue with jsPDF.html() - it can't render multiple html elements concurrently
			//Using this recursive function allows us to add one element at a time
			let addNote = () => {
				if (nodeIndex < notes.length) {
					let n = notes[nodeIndex];
					let nWidth = n.getAttr('width') * n.getAttr('scaleX');
					let noteTitle = `<p style="text-align:center; width:${nWidth}; font-size:${n.getAttr('scaleX')}rem; font-weight:600">Note&nbsp;${nodeIndex+1}</p>`;
					let dataPageTitle = `<p style="text-align:center; width:${nWidth}; font-weight:600">Note&nbsp;${nodeIndex+1}</p>`;
					
					// First add the 'Note x' on the note image on canvas
					pdf.html(noteTitle,{
						x: n.getAttr('x') - posX + 2,
						y: n.getAttr('y') - posY,
						width: nWidth,
						windowWidth: nWidth,
						html2canvas: {
							backgroundColor: "rgba(0, 0, 0, 0)",
						},

						callback: () =>{
							if (ceil((nodeIndex+1) / columnSplit) >= pageCount){
								pdf.addPage([dataPageHeight, dataPageWidth]);
								pageCount++;
							}
							else {
								pdf.setPage(pageCount);
							}

							//Then add the actual contents of the note on a new page
							let colIndex = (nodeIndex % columnSplit);
							pdf.html(dataPageTitle + n.getAttr('dataNote'),{
								x: ((columnWidth + margin * ((columnSplit-1) / columnSplit)) * colIndex) + margin,
								y: (dataPageHeight * (pageCount - 1)) + margin,
								width: columnWidth - (margin / (columnSplit + 1)),
								windowWidth: columnWidth,
								callback: () => {
									nodeIndex++;
									pdf.setPage(1);
									addNote();
								}
							});
						}
					});
				} else {
					pdf.save();
				}
			}

			addNote();
		}
	}

	displayShareSwatchModal() {
		$(document.body).append(this.getShareSwatchModalTemplate()(this.data));
		let $modal = $('#woolLabShareSwatchModalBlock');

		let modalData = {};
		modalData.shareSwatchesApi = this.shareSwatchesApi;
		modalData.selectedSwatchIds = this.swatchIds;

		new WoolLabShareSwatchModalBlock($modal[0], modalData);

		$modal.modal('show');
		$('body').css('padding-right', '0');
		$modal.css('padding', '0');

		$modal.on('shown.bs.modal', () => {
			// need to manually add "in" class so backdrop can display properly due to IDS override
			$('.modal-backdrop').addClass('in');
		});

		$modal.on('hidden.bs.modal', () => {
			$modal.remove();
			$('body').css('padding-right', '');
		});
	}

	getRenameMoodboardModalTemplate() {
        let modalWidget = require('../../partials/widgets/woolLabRenameMoodboardModalBlock.hbs');

		Handlebars.registerPartial('woolLabRenameMoodboardModalBlock', modalWidget);

		let template = `
			{{> woolLabRenameMoodboardModalBlock
				wg="woolLabRenameMoodboardModalBlock"
				ns="WoolLabRenameMoodboardModalBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	displayRenameMoodboardModal() {
		$(document.body).append(this.getRenameMoodboardModalTemplate()(this.data));
		let $modal = $('#woolLabRenameMoodboardModalBlock');

		new WoolLabRenameMoodboardModalBlock($modal[0]);

		$modal.modal('show');
		$('body').css('padding-right', '0');
		$modal.css('padding', '0');

		$modal.on('shown.bs.modal', () => {
			// need to manually add "in" class so backdrop can display properly due to IDS override
			$('.modal-backdrop').addClass('in');
		});
		$modal.on('hidden.bs.modal', () => {
			let input = $('.woolLabRenameMoodboardModalBlock-shareSwatch-textInput').val().trim();
			if (input.length > 0) {
				this.moodboardName = input;
				this.saveItems();
			}
		$modal.remove();
		$('body').css('padding-right', '');
			
		});

		
	}


	addSwatchesToMoodboard(items) {
		const This = this;
		if (items.length > 0) {
			items.forEach((item, i) => {
				let pos = {x: 100 + (i * this.newItemGridSpacing), y: 100 };
				let swatchItem = {'type': 'swatch', 'swatch': item};
				This.generateImage(pos, swatchItem);
			});
		}
		this.saveSwatchesFromPD();
	}
}
